import { Injectable } from '@angular/core';
import { toImmutableMap } from '@datachain/ui-sdk/common';

import { ITraceResponse } from '../requesters/trace/trace.model';
import { TraceItemEntity } from './components/trace-list/trace-item.entity';
import { TraceListEntity } from './components/trace-list/trace-list.entity';

@Injectable()
export class TraceAdapter {
	public constructor() {}

	public generateTraceList(
		response: ReadonlyArray<ITraceResponse>
	): TraceListEntity {
		const list = TraceListEntity.build([
			{
				field: 'code',
				alias: $localize`:i18n=@@trace.list.column.code:`,
				type: 'string',
				isSearchable: true,
				isFilterable: true,
				hasHeaderFilter: false,
				visible: true,
				visibleIndex: 0,
			},
			{
				field: 'usedDate',
				alias: $localize`:i18n=@@trace.list.column.usedDate:`,
				type: 'string',
				isSearchable: true,
				isFilterable: true,
				hasHeaderFilter: false,
				visibleIndex: 1,
			},
			{
				field: 'action',
				alias: $localize`:i18n=@@trace.list.column.action:`,
				type: 'string',
				isSearchable: false,
				isFilterable: false,
				hasHeaderFilter: false,
				visibleIndex: 2,
			},
			{
				field: 'details',
				alias: $localize`:i18n=@@trace.list.column.details:`,
				type: 'string',
				isSearchable: false,
				isFilterable: false,
				hasHeaderFilter: false,
				visibleIndex: 3,
			},
			{
				field: 'element',
				alias: $localize`:i18n=@@trace.list.column.element:`,
				type: 'string',
				isSearchable: true,
				isFilterable: true,
				hasHeaderFilter: false,
				visibleIndex: 4,
			},
		]);
		const items = response.reduce<Array<TraceItemEntity>>((acc, item) => {
			const temp = this.generateTraceItemEntity(item);
			acc.push(temp);
			return acc;
		}, []);

		return list.setElements(toImmutableMap(items, 'id'));
	}

	private generateTraceItemEntity(response: ITraceResponse): TraceItemEntity {
		return TraceItemEntity.build({
			id: response.id,
			code: response.action ?? '',
			action: response.msg ?? '',
			usedDate: response.date ? new Date(response.date) : null,
			details: '', // TO FIX
			element: '', // TO FIX
		});
	}
}
